import { Inject, Injectable, ApplicationRef, Injector, Type } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { DynamicDialogCleanupService } from './dynamic-dialog-cleanup.service';

/**
 * Drop-in replacement for PrimeNG's `DialogService` that automatically
 * tracks every DynamicDialog opened via `open()` with the
 * `DynamicDialogCleanupService`. This ensures all dialogs (including
 * nested ones) are closed on session expiry without requiring manual
 * `track()` calls in every component.
 */
@Injectable()
export class TrackedDialogService extends DialogService {

  constructor(
    appRef: ApplicationRef,
    injector: Injector,
    @Inject(DOCUMENT) document: Document,
    private readonly cleanupService: DynamicDialogCleanupService,
  ) {
    super(appRef, injector, document);
  }

  override open(componentType: Type<any>, config: DynamicDialogConfig): DynamicDialogRef {
    const ref = super.open(componentType, config);
    this.cleanupService.track(ref);
    return ref;
  }
}
